import { render, staticRenderFns } from "./i-loading.vue?vue&type=template&id=4cb76f22&scoped=true"
import script from "./i-loading.vue?vue&type=script&lang=js"
export * from "./i-loading.vue?vue&type=script&lang=js"
import style0 from "./i-loading.vue?vue&type=style&index=0&id=4cb76f22&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb76f22",
  null
  
)

export default component.exports